export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_image') || '图片',
    field: 'displayImage',
    align: 'center',
    width: 150,
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_samplePropertiesName') || '中文名称',
    field: 'samplePropertiesName',
    minWidth: 250,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_samplePropertiesNameEn') || '英文名称',
    field: 'samplePropertiesNameEn',
    minWidth: 250,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_samplePropertiesType') || '图片类型',
    field: 'samplePropertiesType',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'samplePropertiesType' },
  },
]
